export const PaypalIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="28" height="28" fill="white" />
      <rect width="28" height="28" stroke="#E4E4E7" />
      <g clipPath="url(#clip0_816_29625)">
        <path
          d="M11.0482 20.8433L11.3027 19.227L10.7359 19.2139H8.0293L9.91021 7.28762C9.91581 7.25118 9.93432 7.21796 9.96237 7.19403C9.99041 7.17009 10.0261 7.15703 10.063 7.15723H14.6266C16.1417 7.15723 17.1872 7.4725 17.7331 8.09477C17.989 8.38669 18.152 8.69174 18.2308 9.02744C18.3135 9.37969 18.315 9.80054 18.2342 10.3138L18.2284 10.3513V10.6802L18.4843 10.8252C18.6797 10.9241 18.8553 11.058 19.0025 11.2202C19.2214 11.4698 19.363 11.787 19.4228 12.1631C19.4846 12.5499 19.4642 13.0102 19.363 13.5312C19.2462 14.1306 19.0574 14.6527 18.8025 15.0799C18.5776 15.4625 18.2751 15.794 17.9146 16.0529C17.576 16.2933 17.1736 16.4757 16.7187 16.5925C16.2779 16.7073 15.7753 16.7652 15.2241 16.7652H14.8689C14.6149 16.7652 14.3683 16.8567 14.1746 17.0206C13.9813 17.1863 13.853 17.4153 13.8127 17.6667L13.7859 17.8122L13.3363 20.6608L13.3159 20.7654C13.3106 20.7985 13.3013 20.815 13.2877 20.8262C13.2745 20.837 13.258 20.843 13.241 20.8433H11.0482Z"
          fill="#253B80"
        />
        <path
          d="M18.7266 10.3887C18.713 10.4758 18.6974 10.5648 18.6799 10.6563C18.0781 13.7462 16.0191 14.8136 13.3894 14.8136H12.0505C11.7289 14.8136 11.4579 15.0472 11.4078 15.3644L10.7223 19.712L10.5281 20.9444C10.5204 20.9933 10.5234 21.0433 10.5368 21.0909C10.5502 21.1385 10.5738 21.1827 10.606 21.2203C10.6381 21.258 10.678 21.2882 10.7229 21.3089C10.7679 21.3296 10.8168 21.3404 10.8663 21.3404H13.241C13.5222 21.3404 13.7611 21.1361 13.8054 20.8588L13.8287 20.7381L14.2759 17.9007L14.3046 17.745C14.3484 17.4667 14.5877 17.2623 14.8689 17.2623H15.2241C17.5249 17.2623 19.326 16.3282 19.8524 13.6251C20.0724 12.4958 19.9585 11.5529 19.3766 10.8898C19.1922 10.6847 18.9719 10.5148 18.7266 10.3887Z"
          fill="#179BD7"
        />
        <path
          d="M18.097 10.1381C17.9048 10.0825 17.7093 10.0391 17.5117 10.0082C17.1212 9.94815 16.7265 9.91935 16.3314 9.92205H12.7544C12.6183 9.92194 12.4866 9.97054 12.3832 10.0591C12.2798 10.1476 12.2114 10.2702 12.1905 10.4047L11.4296 15.2242L11.4077 15.3648C11.4314 15.2114 11.5093 15.0715 11.6271 14.9705C11.745 14.8695 11.8952 14.814 12.0504 14.8141H13.3893C16.019 14.8141 18.078 13.7462 18.6799 10.6567C18.6979 10.5652 18.7129 10.4762 18.7266 10.3891C18.5677 10.3058 18.4022 10.236 18.2318 10.1804C18.1871 10.1656 18.1421 10.1515 18.097 10.1381Z"
          fill="#222D65"
        />
        <path
          d="M12.1906 10.404C12.2114 10.2694 12.2797 10.1468 12.3831 10.0583C12.4866 9.96983 12.6184 9.92141 12.7545 9.92183H16.3315C16.7552 9.92183 17.1508 9.94957 17.5118 10.008C17.7561 10.0463 17.997 10.1038 18.2323 10.1797C18.4099 10.2386 18.5748 10.3081 18.7271 10.3884C18.9062 9.24653 18.7257 8.46906 18.1083 7.76505C17.4276 6.99002 16.1991 6.6582 14.6272 6.6582H10.0635C9.74241 6.6582 9.4685 6.89174 9.41887 7.20944L7.518 19.2583C7.50915 19.3143 7.51252 19.3714 7.52788 19.426C7.54324 19.4805 7.57022 19.531 7.60698 19.5741C7.64374 19.6172 7.68939 19.6518 7.7408 19.6756C7.79221 19.6993 7.84816 19.7117 7.90479 19.7118H10.7223L11.4297 15.2235L12.1906 10.404Z"
          fill="#253B80"
        />
      </g>
      <defs>
        <clipPath id="clip0_816_29625">
          <rect
            width="13"
            height="16"
            fill="white"
            transform="translate(7.5 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
